import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { constants } from 'common/helpers'

import CloseIcon from 'components/ui/CloseIcon/CloseIcon'

import Image from './Image/Image'
import Info from './Info/Info'
import Counter from './Counter/Counter'
import Price from './Price/Price'
import GiftManual from './GiftManual/GiftManual'

import s from './OrderItem.scss'


const CartOrderItem = (props) => {
  const { data, onIncreaseCount, onDecreaseCount, onRemove } = props
  const { category, image, imageCheckout, amount, price, discount, needDiscountOffer, isLocked } = data
  let { url } = data

  const isGiftSet           = category === 'Gift Set'
  const isProductsSet       = category === 'Product Set'
  const isRemoveVisible     = Boolean(props.isRemoveVisible && onRemove) // eslint-disable-line
  const isCounterVisible    = Boolean(props.isCounterVisible && onIncreaseCount && onDecreaseCount) // eslint-disable-line

  // Remove urls for Product Sets
  if (isProductsSet) {
    url = null
  }

  // TODO it's weird but in cssModules time there was global className "cartOrderItem"
  const rootClassName = cx(s.item, 'cartOrderItem', {
    [s.locked]: isLocked,
    [s.hasLink]: url,
  })

  return (
    <div className={rootClassName}>
      {
        isRemoveVisible && (
          <CloseIcon
            className={s.remove}
            brandColor
            onClick={() => onRemove(data)}
            dataTestId={constants.testIds.payment.removeOrderItem}
          />
        )
      }
      <Image
        className={s.image}
        {...{ url, image, imageCheckout }}
      />
      <div className={s.content}>
        <div className={s.contentInner}>
          <Info {...{ ...data, isGiftSet }} />
          {
            isCounterVisible && (
              <Counter
                amount={amount}
                onIncrease={() => onIncreaseCount(data)}
                onDecrease={() => onDecreaseCount(data)}
              />
            )
          }
          <Price {...{ price, discount, isLocked }} />
        </div>
        {
          needDiscountOffer && (
            <GiftManual isGiftSet={isGiftSet} />
          )
        }
      </div>
    </div>
  )
}

CartOrderItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.any,
    image: PropTypes.string,
    imageCheckout: PropTypes.string,
    brand: PropTypes.string,
    name: PropTypes.string,
    category: PropTypes.string,
    volume: PropTypes.any,
    amount: PropTypes.number,
    price: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  isCounterVisible: PropTypes.bool,
  isRemoveVisible: PropTypes.bool,
  onIncreaseCount: PropTypes.func,
  onDecreaseCount: PropTypes.func,
  onRemove: PropTypes.func,
}

CartOrderItem.defaultProps = {
  isCounterVisible: true,
  isRemoveVisible: true,
}


export default React.memo(CartOrderItem)
